import React, { useEffect } from 'react';

import ProgramOrderTopicPage from 'components/Members/Programs/Views/New/OrderTopics/Index';

import { useContext } from 'components/Members/Onboarding/Context';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useContext as useProgramContext } from 'components/Members/Programs/Views/Show/Context';
import { useContext as useUsersContext } from 'components/Users/Context';

import {
  useParams,
} from 'react-router-dom';

import StepTab from 'components/new_ui/Tabs/StepTab';

export default function OrderTopic() {
  const { dispatch, state, actions } = useContext();
  const { dispatch: dispatchProgram, actions: actionsProgram, state: stateProgram } = useProgramContext();
  const { state: stateUsers } = useUsersContext();

  const { programId } = useParams();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  useEffect(() => {
    actionsProgram.load(dispatchProgram, programId);
  }, [programId]);

  if (stateProgram.program === null || stateUsers.user === null) {
    return (
      <div className="content onboarding-content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="onboarding-content">
      <StepTab total={5} current={2} />

      <ProgramOrderTopicPage
        showSteps={false}
        onNextStep={onGoNextClick}
      />
    </div>
  );
}
